<template>
    <div class="flex items-baseline gap-3">
        <Price 
            :value="price" 
            :currency="resolvedCurrency" 
            class="font-bold"
        />
        <span v-if="oldPrice && oldPrice != price" class="text-[0.6em] text-gray-500 dark:text-gray-400 line-through">
            <Price :value="oldPrice" :currency="resolvedCurrency" />
        </span>
    </div>
</template>
<script setup lang="ts">
import Price from '~/components/molecules/Price.vue'
import { useCurrencyStore } from '~/stores/useCurrencyStore'

const currencyStore = useCurrencyStore()

const {
    currency
} = defineProps<{ price: number; currency?: string; oldPrice?: number }>()

const resolvedCurrency = computed(() => {
    return currency || currencyStore.currency
})

</script>